import isPositiveInteger from "@/utils/isPositiveInteger";

const isInValueRange = (
  string: string | number,
  minValue: number,
  maxValue: number,
) => {
  const number = Number(string);

  if (isPositiveInteger(number)) {
    const papMinValue = Math.max(minValue, 1);

    if (number >= papMinValue && number <= maxValue) {
      return true;
    }
  }

  return false;
};

export default isInValueRange;
